<template>
<h1><font-awesome-icon icon="sun" /></h1>
<u>UV-Index</u>
<br>
<SemiGauge id="uv" :value="uvindex" :min="0" :max="12" :zones="ZONES" :ticks="TICKS" />
<b>{{ valid ? uvindex : '--' }}</b>
<div v-if="level"><b>{{ level.name }}</b> &ndash; {{ level.advice }}</div>
</template>

<script>
import SemiGauge from './semi_gauge.vue'

// WHO UV index categories: [from, to, color]
const ZONES = [
  [0, 3, '#22a447'],
  [3, 6, '#f2d400'],
  [6, 8, '#f08a00'],
  [8, 11, '#d82a1f'],
  [11, 12, '#7b3fb5']
]

const TICKS = []
for (let v = 0; v <= 12; v++) {
  TICKS.push(v % 2 === 0 ? { v, size: 'major', label: String(v) } : { v, size: 'mid' })
}

// upper bound (exclusive) of each category
const LEVELS = [
  { below: 3, name: 'niedrig', advice: 'kein Sonnenschutz nötig' },
  { below: 6, name: 'mäßig', advice: 'Sonnenschutz empfohlen' },
  { below: 8, name: 'hoch', advice: 'Sonnenschutz nötig' },
  { below: 11, name: 'sehr hoch', advice: 'Mittagssonne meiden' },
  { below: Infinity, name: 'extrem', advice: 'Aufenthalt im Freien vermeiden' }
]

export default {
  name: 'UvIndex',
  components: { SemiGauge },
  props: {
    uvindex: Number
  },
  data() {
    return { ZONES, TICKS }
  },
  computed: {
    valid() {
      return Number.isFinite(this.uvindex)
    },
    level() {
      return this.valid ? LEVELS.find(l => this.uvindex < l.below) : null
    }
  }
}
</script>
